var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.648 6.95764L17.1916 25.0151H16.1856L1.52686 7.14604L5.98198 0.834717H26.6384L30.648 6.95764Z",
    fill: "#3063CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8541 6.95337L21.3642 8.34996L17.0049 25.0191H17.4121L30.8541 6.95337Z",
    fill: "#7CA7FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.8623 6.95337L11.3522 8.34996L16.1666 25.0191H15.7642L1.8623 6.95337Z",
    fill: "#7CA7FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5267 8.71891L16.2236 0.810303L26.4944 0.941362L21.1913 8.71891H21.5267Z",
    fill: "#7CA7FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5101 8.71891L6.20703 0.810303L16.4778 0.941362L11.1747 8.71891H11.5101Z",
    fill: "#7CA7FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1171 24.8144L0.956543 7.18283L5.71346 0.445557H26.916L31.1891 6.99852L17.9531 24.7734C17.802 24.9759 17.5946 25.1433 17.3494 25.2606C17.1042 25.3778 16.8289 25.4413 16.548 25.4453C16.2671 25.4494 15.9894 25.3939 15.7397 25.2838C15.49 25.1737 15.2761 25.0124 15.1171 24.8144ZM2.09666 7.15415L15.9075 24.3557C15.9811 24.4375 16.0761 24.5034 16.1849 24.5481C16.2937 24.5929 16.4133 24.6151 16.534 24.6131C16.6547 24.6111 16.7731 24.5849 16.8798 24.5367C16.9865 24.4884 17.0785 24.4194 17.1483 24.3352L30.0825 6.96576L26.3555 1.26468H6.23562L2.09666 7.15415Z",
    fill: "#0C1F70"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8872 0.602046L10.5845 8.51172L11.4157 8.91905L16.7184 1.00938L15.8872 0.602046Z",
    fill: "#0C1F70"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7214 0.61269L15.8901 1.02002L21.1929 8.92969L22.0241 8.52236L16.7214 0.61269Z",
    fill: "#0C1F70"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1617 0.726273L20.8589 8.50342L21.6866 8.91595L26.9895 1.1388L26.1617 0.726273Z",
    fill: "#0C1F70"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.45125 0.727609L5.62354 1.14014L10.9288 8.92083L11.7565 8.5083L6.45125 0.727609Z",
    fill: "#0C1F70"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6189 8.48294L10.6938 8.69604L15.8711 25.1233L16.7962 24.9102L11.6189 8.48294Z",
    fill: "#0C1F70"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9123 8.50767L16.3384 24.9348L17.2704 25.1245L21.8443 8.69736L20.9123 8.50767Z",
    fill: "#0C1F70"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2895 8.63662L1.45947 7.43251L1.5936 6.61339C13.6272 8.08781 9.17689 7.8134 21.1147 7.8134L30.5615 6.4209L30.7244 7.24002C19.0165 8.95608 23.4524 8.63662 11.2895 8.63662Z",
    fill: "#0C1F70"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.0c4e4c791eb969b086dcb3ebdb6ed23d.svg";
export { ForwardRef as ReactComponent };